import { render, staticRenderFns } from "./WLoader.vue?vue&type=template&id=7444cb4f&scoped=true&"
import script from "./WLoader.vue?vue&type=script&lang=js&"
export * from "./WLoader.vue?vue&type=script&lang=js&"
import style0 from "./WLoader.vue?vue&type=style&index=0&id=7444cb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444cb4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
